export default __webpack_public_path__ + "static/media/Optometry.1b0f610d.png";